import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { makeStyles } from '@material-ui/core';
import colors from '../../foundations/colors.module.scss';
import typography from '../../foundations/typography.module.scss';
import { baseMenuPaperStyles, baseMenuItemStyles } from '../Menu/Menu.styles';
export const useAutocompleteStyles = makeStyles({
    option: (param)=>{
        let { disableSelectedHighlight } = param;
        return _object_spread_props(_object_spread({}, baseMenuItemStyles), {
            // Autocomplete-specific overrides
            lineHeight: typography.lineHeightP1,
            // Autocomplete uses data attributes instead of CSS classes
            '&[data-focus="true"]': {
                backgroundColor: disableSelectedHighlight ? "".concat(colors.dark70, " !important") : colors.dark70
            },
            '&[aria-selected="true"]': {
                backgroundColor: disableSelectedHighlight ? 'inherit' : colors.dark120
            },
            '&[aria-disabled="true"]': {
                pointerEvents: 'inherit'
            },
            '&[aria-disabled="true"]:active': {
                pointerEvents: 'none'
            }
        });
    },
    optionDivider: {
        height: 1,
        backgroundColor: colors.dark200,
        margin: '8px 8px'
    },
    endAdornment: {
        paddingRight: 8
    },
    popper: {
        marginBottom: '4px'
    },
    paper: _object_spread({}, baseMenuPaperStyles),
    inputRoot: (param)=>{
        let { hasMultipleChips } = param;
        return {
            flexWrap: 'wrap',
            paddingTop: hasMultipleChips ? 4 : undefined,
            backgroundColor: colors.dark50,
            '&.MuiOutlinedInput-adornedEnd': {
                paddingRight: '52px !important'
            },
            '& input': {
                width: 0,
                minWidth: 40,
                flexGrow: 1
            }
        };
    }
});
